module.exports = __webpack_public_path__ + "static/media/pink-header-bg.ce84f556.png";